import { transport } from 'config/transport';

export function callApiExportPhieuThu(congDoanId, classId, month, paymentDueDate, paymentSentDate, studentIds, type, subjectIds) {
    console.log(subjectIds);
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${classId}/phieuthu/exportPhieuThuPdf`, {
        params: { month, paymentDueDate, paymentSentDate, studentIds, type, subjectIds: subjectIds.join(',') },
        responseType: 'blob',
    });
}
